export const SPECIES_TERMS = {
  dog: { male: "Stud", female: "Dam" },
  cat: { male: "Tom", female: "Queen" },
  horse: { male: "Stallion", female: "Mare" },
  cattle: { male: "Bull", female: "Cow" },
  goat: { male: "Buck", female: "Doe" },
  sheep: { male: "Ram", female: "Ewe" },
  pig: { male: "Boar", female: "Sow" },
  rabbit: { male: "Buck", female: "Doe" },
  poultry: { male: "Rooster", female: "Hen" },
  default: { male: "Sire", female: "Dam" },
};

export function getTerms(species) {
  const key = (species || "").toLowerCase();
  return SPECIES_TERMS[key] || SPECIES_TERMS.default;
}

// Map our marketplace slugs to term species keys
export function termsSpeciesKeyFromSlug(speciesSlug) {
  const s = (speciesSlug || "").toLowerCase();
  if (s === "equine") return "horse";
  if (s === "canine") return "dog";
  if (s === "feline") return "cat";
  if (s === "cattle") return "cattle";
  return "default"; // exotics or unknown
}
